// Product_card_2.js
import React, { useContext, useEffect, useState } from "react";
import "./Product_card_2.css";
import { Link, useNavigate } from "react-router-dom";
import Like_Btn from "../../common_btn/like_btn/Like_Btn";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Pink_Btn from "../../common_btn/pink_btn/Pink_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import StarRatings from "react-star-ratings";
import { Context } from "../../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist, postWishlist } from "../../../../features/wishlist/wishlistSlice";
import { AvgReviewRating } from "../../../../features/reviewRating/reviewRatingSlice";
import { getAllCart, postCart } from "../../../../features/cart/cartSlice";
import Login_Layout_Modal from "../../modals/login-signup-modals/Login_Layout_Modal";

import Increment_Decrement_Btn from "../../common_btn/Increment_Decrement_Btn/Increment_Decrement_Btn"
import Confirm_delivery_add_offcanvas from "../../offcanvas/confirm-delivery-add-offcanvas/Confirm_delivery_add_offcanvas";
import { encodeId } from "../../../../utils/common";
const Product_card_2 = ({ product, ...props }) => {
  const { signin } = useContext(Context);
  const navigate = useNavigate();

  const [modelType, setModelType] = useState("");
  const [selectLogin, setSelectLogin] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [addoffcanvas, setAddoffcanvas] = useState(false);

  const dispatch = useDispatch();

  const postWishlistData = async (data) => {
    const res = await dispatch(postWishlist({ product_id: data }));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
    } else if (res.meta?.requestStatus === "rejected") {
    }

  };
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);



  useEffect(() => {
    if (signin)
      dispatch(getAllWishlist());
  }, [dispatch, props?.id]);


  function calculateDiscountPercentage(mrp, sellingPrice) {


    if (typeof mrp !== 'number' || typeof sellingPrice !== 'number') {
      throw new Error("MRP and selling price must be numbers.");
    }

    if (mrp < 0) {
      throw new Error("MRP must be a positive number.");
    }

    const discountAmount = mrp - sellingPrice;
    const discountPercentage = (discountAmount / mrp) * 100;

    // Optional: Round the result to two decimal places
    return parseFloat(discountPercentage.toFixed(2));
  }




  const ProductBuyNow = async () => {
    try {
      const data = {
        product_id: props?.id,
        Product: props?.product,
        quantity: quantity,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: signin }));

      if (res.meta?.requestStatus === "fulfilled") {
        navigate("/cart")
        await dispatch(getAllCart(signin));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  const ProductAddToCart = async () => {
    try {
      const data = {
        product_id: props?.id,
        Product: props?.product,
        quantity: quantity,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: signin }));

      if (res.meta?.requestStatus === "fulfilled") {
        // navigate("/cart")
        await dispatch(getAllCart(signin));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  const [addCartBTNShow, setaddCartBTNShow] = useState(false);
  const allCart = useSelector((state) => state.cart.allCarts);

  useEffect(() => { dispatch(getAllCart(signin)); }, [dispatch, product])


  return (
    <section className="Product_card_2">
      <div className="top_div">
        <div className="img_div" onClick={() => navigate(`${props?.link}`)}>
          <img className="productimg" src={props.image} alt="productimg" />
        </div>

        <div className="discount_div">
          <p className="discount_text">{calculateDiscountPercentage(parseInt(props.oldprise), parseInt(props.prise))}% Off</p>
        </div>

        <div className="wishlist_btn">


          {signin &&
            <Like_Btn
              isActive={allWishlist?.data?.some((item) => item.product_id === props?.id)}
              onClick={() => postWishlistData(props?.id)}
            />
          }
          {!signin &&
            <Like_Btn
              isActive={allWishlist?.data?.some((item) => item.product_id === props?.id)}
              onClick={() => { setModelType("select_login"); setSelectLogin(true); }}
            />
          }
        </div>
      </div>

      <div className="contentdiv">
        <p className="prodname" onClick={() => navigate(`/product-details/${encodeId(props?.id)}`)}>
          {props.name}
        </p>
        <div className="row ms-0 me-0">
          <div className="col-sm-7 p-1">
            <p className="subname">{props.subname}</p>
            <StarRatings
              rating={Number(props?.average_rating || 0)}
              starDimension="14px"
              starSpacing="0px"
              starRatedColor="#26a500"
            />
          </div>
          <div className="col-sm-5 p-1">
            <p className="oldprice">₹{props.oldprise}</p>
            <p className="prise">₹{props.prise}</p>
          </div>
        </div>
      </div>

      <div className="btns_holder">
        <Light_Black_Btn
          btnText={"Buy Now"}
          onClick={ProductBuyNow}
        />

        <div className="desktop_view_cart_btn">

          {addCartBTNShow || allCart?.data?.data?.some((item) => item?.product_id == product?.id) ? (
            <Increment_Decrement_Btn
              setaddCartBTNShow={setaddCartBTNShow}
              product={product}
              cart={allCart?.data?.data}
              productId={product?.id}
              isSignIn={signin}
              setQuantity={setQuantity}
              quantity={quantity}
            />
          ) : (
            <Pink_Btn
              btnText={"Add to Cart"}
              onClick={ProductAddToCart}
            />
          )}

        </div>

        <Link to={"/cart"}>
          <div className="mobile_view_cart_btn">
            <FontAwesomeIcon icon={faShoppingCart} className="cart_icon" />
          </div>
        </Link>
      </div>
      <Login_Layout_Modal
        modalType={modelType}
        show={selectLogin}
        onHide={() => setSelectLogin(false)}
      />
      <Confirm_delivery_add_offcanvas
        show={addoffcanvas}
        onHide={() => setAddoffcanvas(false)}
      />

    </section>

  );
};

export default Product_card_2;
